import React from 'react';
import Background from "./back1.jpg";
import WaterWave from "react-water-wave";

const Fuel = () => {
  return (
    <WaterWave
      style={{
        width: '100vw', // Make sure this matches the viewport width
        height: '100vh', // Make sure this matches the viewport height
        background: `url(${Background}) no-repeat center center fixed`,
        backgroundSize: 'contain',
      }}
      dropRadius={20}
      perturbance={0.04}
      interactive={true}
    >
      {({ getCanvas }) => (
        <canvas
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
          ref={getCanvas} 
        />
      )}
    </WaterWave>
  );
};

export default Fuel;
